import { useEffect, useRef, useState, type RefObject } from "react";
import { findScrollParent } from "src-next/modules/clinical-insights/helpers/findScrollParent";

const DEBOUNCE_MS = 120;

export function usePeriodBarVisibility(
  containerRef: RefObject<HTMLElement | null>
): boolean {
  const [isPeriodBarVisible, setIsPeriodBarVisible] = useState(true);
  const debounceRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    const element = containerRef.current;
    if (!element) return;

    const root = findScrollParent(element);
    const observer = new IntersectionObserver(
      ([entry]) => {
        const next = entry.isIntersecting;
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
          setIsPeriodBarVisible(next);
        }, DEBOUNCE_MS);
      },
      {
        root,
        threshold: 0,
        rootMargin: "8px 0px 0px 0px",
      }
    );

    observer.observe(element);
    return () => {
      observer.disconnect();
      clearTimeout(debounceRef.current);
    };
  }, [containerRef]);

  return isPeriodBarVisible;
}
